var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-heading",attrs:{"id":_vm.id}},[_c('h2',{staticClass:"no-margin-top"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }